import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useEffect, useState } from 'react';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  fullScreen?: boolean;
  className?: string;
}

export const LoadingSpinner = ({
  size = 'md',
  fullScreen = false,
  className,
}: LoadingSpinnerProps) => {
  const [currentTheme, setCurrentTheme] = useState<string>('light');

  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
  };

  useEffect(() => {
    // Get theme from localStorage directly to avoid dependency on theme context
    // Use the same storage key as defined in main.tsx
    const storedTheme = localStorage.getItem('capitol-ui-theme') || 'system';

    let resolvedTheme = storedTheme;
    if (storedTheme === 'system') {
      resolvedTheme = window.matchMedia('(prefers-color-scheme: dark)').matches
        ? 'dark'
        : 'light';
    }

    setCurrentTheme(resolvedTheme);

    // Apply theme to document root immediately
    const root = document.documentElement;
    root.classList.remove('light', 'dark');
    root.classList.add(resolvedTheme);
  }, []);

  const spinner = (
    <Loader2 className={cn('animate-spin', sizeClasses[size], className)} />
  );

  if (fullScreen) {
    return (
      <div
        className={cn(
          'fixed inset-0 z-50 flex items-center justify-center bg-background/80 backdrop-blur-sm',
          currentTheme,
        )}
      >
        <div className='flex items-center justify-center'>{spinner}</div>
      </div>
    );
  }

  return <div className='flex items-center justify-center'>{spinner}</div>;
};
